/*
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-03-29 13:49:26
 * @LastEditTime: 2022-05-25 10:29:30
 */
import { user, login } from '@/api/ajax';
import { setToken, getToken } from '@/tools/auth';
import { setStorage } from '@/tools/storage';
import { userGuide } from '@/assets/staticData';
import qiankunStore from '@/qiankun/store'; // qiankun

let testData = {
  returnCode: '100',
  returnMsg: '请求成功',
  returnData: {
    usermodel: {
      username: '',
      sessionid: '',
      menus: userGuide,
      rules: ['delete', 'xiugai', 'add']
    }
  }
};

function asyncMenus(obj) {
  const mList = [];
  obj.filter(item => {
    item.menus.filter(item => {
      mList.push(item.menu_url); // todo: menu_url
    });
  });
  return mList;
}

function compare(property) {
  // 排序
  return function(a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value1 - value2;
  };
}

const aside = {
  state: {
    defaultAsideActive: '', //aside active
    tabActive: '', //header导航
    isCollapse: false, // 折叠导航
    buttonList: [], // button 权限列表
    menusRoles: [], // 可进入的 URL

    menusList: {
      // aside 列表
    }
  },

  mutations: {
    CHANGEASIDEACTIVE: (state, item) => {
      state.defaultAsideActive = item;
    },
    TABACTIVE: (state, item) => {
      state.tabActive = item;
    },
    ISCOLLAPSE: (state, item) => {
      state.isCollapse = item;
    },
    SET_MENUSLIST: (state, item) => {
      state.menusList = item;
    },
    SET_MENUSROLES: (state, item) => {
      state.menusRoles = item;
    },
    SET_BUTTON: (state, item) => {
      state.buttonList = item;
    }
  },
  actions: {
    GetUserRoles({ commit }, resp) {
      let data = testData; // todo
      if (resp.data) {
        data.returnData.usermodel.sessionid = resp.data.data.token;
        data.returnData.usermodel.username = resp.data.data.user.userName;
      } else if (resp.returnData) {
        data.returnData.usermodel.sessionid =
          resp.returnData.usermodel.sessionid;
        data.returnData.usermodel.username = resp.returnData.usermodel.username;
      }

      return new Promise(resolve => {
        let usermodel = data.returnData.usermodel;

        setStorage('userAuthData', data);
        let resp = usermodel;
        let token = usermodel.sessionid;
        let buttonState = resp.rules;
        let menus = resp.menus;
        let editMenus = {};
        if (!getToken()) {
          setToken(token);
        }
        qiankunStore.setGlobalState({ token }); // qiankun: 同步到子服务中
        menus.sort(compare('weight'));
        menus.filter((item, index) => {
          // item.menus.sort(compare('menu_weight'))
          editMenus[item.name] = item;
        });
        commit('SET_MENUSLIST', editMenus);
        // commit('SET_MENUSROLES', asyncMenus(menus))
        commit('SET_BUTTON', buttonState);
        resolve();
      });
    },
    tabActivef({ commit }, data) {
      commit('TABACTIVE', data);
    }
  }
};
export default aside;
